/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { defaultSocialChannelLinks, socialChannelLinks } from './config';

export const getSocialChannelLinks = (marketLanguage: MarketLanguage) => {
    // @ts-ignore - Element implicitly has an any type - Touch and Change
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return socialChannelLinks[marketLanguage] ?? defaultSocialChannelLinks;
};
